import * as types from "../actions/actionTypes";
import initialState from "./initialState";

export default function organizationReducer(
  state = initialState.organization,
  action
) {
  switch (action.type) {
    case types.CREATE_ORGANIZATION_SUCCESS:
      return action.organization;
    case types.UPDATE_ORGANIZATION_SUCCESS:
      return action.organization;
    case types.LOAD_ORGANIZATION_SUCCESS:
      return action.organization;
    default:
      return state;
  }
}
